import { provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';
import {
  getAnalytics,
  provideAnalytics,
  ScreenTrackingService,
} from '@angular/fire/analytics';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { TitleStrategy } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import assert from 'tiny-invariant';

import { provideRouteReuseKeyed } from '@ts/shared/router/util-routes';
import { environment } from '@ts/shared/util-environment';
import { BormadagoTitleStrategy } from '@ts/shared/util-title';

import { provideEnvironmentIndicator } from './environment-indicator.util';
import { initializeSentryProvider } from './sentry.util';

export function provideAnalyticsCallback() {
  return getAnalytics();
}

export function provideFirebaseAppCallback() {
  assert(environment.firebaseConfig);
  return initializeApp(environment.firebaseConfig);
}

export function getAppProviders(): Readonly<
  Array<Provider | EnvironmentProviders>
> {
  return [
    CookieService,
    ...provideRouteReuseKeyed(),
    // One instance: pages inject `BormadagoTitleStrategy` for its `titleUpdated$`.
    { provide: TitleStrategy, useExisting: BormadagoTitleStrategy },
    ...initializeSentryProvider(),
    ...provideEnvironmentIndicator(),
    provideHttpClient(withJsonpSupport()),
    environment.firebaseConfig
      ? [
          ScreenTrackingService,
          provideAnalytics(provideAnalyticsCallback),
          provideFirebaseApp(provideFirebaseAppCallback),
        ]
      : [],
  ];
}
